import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import "./game2.css"

export default function Game2() {
  const [playerPos, setPlayerPos] = useState({ x: 0, y: 0 });
  const [enemyPos, setEnemyPos] = useState({ x: 200, y: 200 });
  const [score, setScore] = useState(0);
  const [gameOver, setGameOver] = useState(false);

  const gameAreaSize = 320;
  const step = 20;
  const playerSize = 50;
  const enemySize = 50;

  // Control tastatură
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (gameOver) return;
      setPlayerPos((prev) => {
        let { x, y } = prev;
        if (e.key === "ArrowUp") y = Math.max(0, y - step);
        if (e.key === "ArrowDown") y = Math.min(gameAreaSize - playerSize, y + step);
        if (e.key === "ArrowLeft") x = Math.max(0, x - step);
        if (e.key === "ArrowRight") x = Math.min(gameAreaSize - playerSize, x + step);
        return { x, y };
      });
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [gameOver]);

  // Miscare inamic
  useEffect(() => {
    if (gameOver) return;
    const interval = setInterval(() => {
      setEnemyPos((prev) => {
        let x = prev.x + (Math.random() > 0.5 ? step : -step);
        let y = prev.y + (Math.random() > 0.5 ? step : -step);
        x = Math.max(0, Math.min(gameAreaSize - enemySize, x));
        y = Math.max(0, Math.min(gameAreaSize - enemySize, y));
        return { x, y };
      });
    }, 800);
    return () => clearInterval(interval);
  }, [gameOver]);

  // Score & coliziune
  useEffect(() => {
    if (gameOver) return;
    const interval = setInterval(() => {
      // verific coliziune
      if (
        playerPos.x < enemyPos.x + enemySize &&
        playerPos.x + playerSize > enemyPos.x &&
        playerPos.y < enemyPos.y + enemySize &&
        playerPos.y + playerSize > enemyPos.y
      ) {
        setGameOver(true);
      } else {
        setScore((prev) => prev + 1);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [playerPos, enemyPos, gameOver]);

  const resetGame = () => {
    setPlayerPos({ x: 0, y: 0 });
    setEnemyPos({ x: 200, y: 200 });
    setScore(0);
    setGameOver(false);
  };

  return (
    <div className="app">
      <h1>Joc React Complex 🎮</h1>
      <p>Score: {score}</p>

      <div className="game-area">
        <motion.div
          className="player"
          animate={{ x: playerPos.x, y: playerPos.y }}
          transition={{ type: "spring", stiffness: 200, damping: 20 }}
        />
        <motion.div
          className="enemy"
          animate={{ x: enemyPos.x, y: enemyPos.y }}
          transition={{ type: "spring", stiffness: 200, damping: 20 }}
        />
        {gameOver && (
          <div className="game-over">
            <h2>Game Over 😢</h2>
            <button onClick={resetGame}>Joacă din nou</button>
          </div>
        )}
      </div>
    </div>
  );
}
